import React from "react";
import "./DeliveryDateSelector.css"; // add CSS below

const DeliveryDateSelector = ({
  deliveryDate,
  setDeliveryDate,
  showCalendar,
  setShowCalendar,
}) => {
  const minDeliveryDate = new Date(Date.now() + 2 * 24 * 60 * 60 * 1000)
    .toISOString()
    .split("T")[0];

  return (
    <div className="delivery-date-box">
      <h4>Select Delivery Date</h4>

      <button
        className="select-date-btn"
        onClick={() => setShowCalendar(!showCalendar)}
      >
        {deliveryDate ? "Change Delivery Date" : "Select Delivery Date"}
      </button>

      {/* ✅ Fullscreen overlay when calendar is open */}
      {showCalendar && (
        <div className="calendar-overlay" onClick={() => setShowCalendar(false)}>
          <div
            className="calendar-container"
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
          >
            <input
              type="date"
              className="calendar-input"
              value={deliveryDate}
              min={minDeliveryDate}
              onChange={(e) => {
                setDeliveryDate(e.target.value);
                setShowCalendar(false);
              }}
            />
          </div>
        </div>
      )}

      {deliveryDate && (
        <p className="selected-date">
          📅 Selected Delivery Date: <strong>{deliveryDate}</strong>
        </p>
      )}
    </div>
  );
};

export default DeliveryDateSelector;
